import { IPulseXConfig } from "@pulsex/types";
import client from "./client";

export default function getDailyPdf(config: IPulseXConfig) {
    return client.get(config["API_URL"], "/posts/todays-newsletter");
}